import { render } from "./algerianTransparency.vue?vue&type=template&id=1fc2a843&scoped=true"
import script from "./algerianTransparency.vue?vue&type=script&lang=js"
export * from "./algerianTransparency.vue?vue&type=script&lang=js"

import "./algerianTransparency.vue?vue&type=style&index=0&id=1fc2a843&scoped=true&lang=css"

import exportComponent from "D:\\Developpement\\HATPLC\\frontend 25122025\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc2a843"]])

export default __exports__